import { titleize } from '../titleize';

export const formatPageTitle = (title: string) => {
  return [titleize(title), 'Moda Operandi'].filter(Boolean).join(' | ');
};
